import React, { useState, useEffect } from "react";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import GrnPOModal from "../components/grnPoModal";
import Time from "../components/time";
import { useParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";

const AddGRN = () => {
  useAuthRedirect();
  const { fld_purnumber } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]); 
  const branch = localStorage.getItem("branch");
  const user = localStorage.getItem("username");
  const [oldPoNumber, setPriNumber] = useState(null);  
  const [supplierNo, setSupplierNo] = useState(null);  
  const [poDate, setPoDate] = useState(null);  
const [freight, setFreight] = useState(""); 
const [poNumber, setPoNo] = useState(""); 
const [subDetails, setSubDetails] = useState({})
const [formData, setFormData] = useState({invoiceNo: "", invoiceDate: "", dcNo: "", dcDate: ""
})
const navigate = useNavigate();

const canEntry  = hasPermission("GRN", "entry");

useEffect(() => {
  const fetchPoNo = async () => {
    try {
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/grn_no`);
      if (response.data.PoNo) {
        const NewPo = parseInt(response.data.PoNo, 10) || 0;
        setPoNo(NewPo.toString());
        setFormData(prevState => ({ ...prevState, PoNumber: NewPo.toString() }));
      }
    } catch (error) {
      console.error("Error fetching indent number:", error);
    }
  };
  fetchPoNo();
}, []);

const handleSelectItem = async (supplier) => {
  try {
    setPriNumber(supplier.PurchaseOrderheader_POnumber); 
    setSupplierNo(supplier.PurchaseOrderHeader_SupplierCode)
    setPoDate(supplier.PurchaseOrderheader_POdate)

    const response = await axios.get("https://rfs2.infraconsoft.net.in/api/grn_selectPendingItems", {
      params: {
        poNo: supplier.PurchaseOrderheader_POnumber,
        idsuppliercode: supplier.PurchaseOrderHeader_SupplierCode,
        branch: branch,
      },
    });

    if (response.data.length > 0) {
      setSelectedItems(response.data);
    }
  } catch (error) {
    console.error("Error fetching supplier items:", error);
  }
};

useEffect(() => {
    const fetchSupplierDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/purchaseOrder_supDetails?supplierCode=${supplierNo}`);
            const items = response.data.supDetails;
            const storeReqHeader1 = {
                supplierMaster_code: items[0].supplierMaster_code || "N/A",
                supplierMaster_name: items[0].supplierMaster_name || "N/A",
            };
            setSubDetails(storeReqHeader1);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchSupplierDetails();
  }, [supplierNo]); 


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (selectedItems.length === 0) {
        Swal.fire("Error", "Please add at least one item", "error");
        return;
    }

     if ((!formData.dcNo)) {
            Swal.fire({
              icon: 'warning',
              title: 'Empty',
              text: `Enter Your DC No!`,
            });
          return;
          }

        if (isNaN(formData.dcNo) || formData.dcNo.trim() === "") {
  Swal.fire({
    icon: 'warning',
    title: 'Invalid DC No',
    text: 'Your DC No should be a number.',
  });
  return;
}


                 if ((!formData.dcDate)) {
            Swal.fire({
              icon: 'warning',
              title: 'Empty',
              text: `Select Your DC Date!`,
            });
          return;
          }

                 if ((!formData.invoiceNo)) {
            Swal.fire({
              icon: 'warning',
              title: 'Empty',
              text: `Enter Invoice No!`,
            });
          return;
          }

          if (isNaN(formData.invoiceNo) || formData.invoiceNo.trim() === "") {
  Swal.fire({
    icon: 'warning',
    title: 'Invalid Invoice No',
    text: 'Invoice No should be a number.',
  });
  return;
}


            if (Number(!formData.invoiceNo)) {
                  Swal.fire({
                    icon: 'warning',
                    title: 'Empty',
                    text: `Invoice No should be Number.`,
                  });
                return;
                }

                 if ((!formData.invoiceDate)) {
            Swal.fire({
              icon: 'warning',
              title: 'Empty',
              text: `Select Your Invoice Date!`,
            });
          return;
          }
    

    const payload = {
        branch: branch,
        grnNo: formData.PoNumber,
        user: user,
        scode: subDetails.supplierMaster_code,
        dcNo: formData.dcNo,
        dcDate: formData.dcDate,
        invoiceNo: formData.invoiceNo,
        invoiceDate: formData.invoiceDate,
        poNo : oldPoNumber,
        poDate : poDate,
        items: selectedItems.map((item) => {
            return {
                itemCode: item.PurchaseOrderDetail_itemCode,
                itemName: item.itemMaster_name,
                itemUom: item.itemMaster_purchaseuom,
                orderedQuantity: item.PurchaseOrderDetail_orderedQuantity,
                price: item.PurchaseOrderDetail_price,
                cst: item.purchaseOrderDetail_cstTax,
                pf: item.purchaseOrderDetail_pfPercentage,
                disc: item.purchaseOrderDetail_discountPercentage,
                value: item.purchaseOrderDetail_value,
            };
        }),
    };


    try {
         Swal.fire({
                    title: "Submitting...",
                    text: "Please wait while we process your request.",
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });

        const response = await axios.post("https://rfs2.infraconsoft.net.in/api/grn_insert", payload);
        Swal.fire("Success", "GRN added successfully", "success");
        // alert("Success");
        setSelectedItems([]);
        navigate('/inventory/grnView');
    } catch (error) {
        console.error("Error submitting form:", error);
        Swal.fire("Error", "Submission failed. Please try again.", "error");
    }
};

   if (!canEntry) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>

           <div className="back-div">
              <h2 className="add-txt">Add GRN</h2>
              <Link to='/inventory/grnView'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
            </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
          <div className="form-row">
              <div className="form-group">
                <label>GRN Number :</label>
                <input type="text" name="PoNumber" value={formData.PoNumber} readOnly />
              </div>
              <div className="form-group">
                <label>GRN Date :</label>
                <input type="date" name="endhrs" value={new Date().toISOString().split("T")[0]} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>PO No :</label>
                <input type="text" name="PoNumber" value={oldPoNumber} readOnly />
              </div>
              <div className="form-group">
                <label>PO Date :</label>
                <input type="text" name="endhrs" value={poDate ? new Date(poDate).toLocaleDateString("en-GB") : ""} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Supplier Code :</label>
                <input type="text" name="scode" value={subDetails.supplierMaster_code} />
              </div>
              <div className="form-group">
                <label>Supplier Name :</label>
                <input type="text" name="sname" value={subDetails.supplierMaster_name}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>DC No :</label>
                <input type="text" name="dcNo" value={formData.dcNo}  onChange={handleChange}/>
              </div>
              <div className="form-group">
                <label>DC Date :</label>
                <input type="date" name="dcDate" value={formData.dcDate}  onChange={handleChange}/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Invoice No :</label>
                <input type="text" name="invoiceNo" value={formData.invoiceNo}  onChange={handleChange}/>
              </div>
              <div className="form-group">
                <label>Invoice Date :</label>
                <input type="date" name="invoiceDate" value={formData.invoiceDate}  onChange={handleChange}/>
              </div>
            </div>

            <div className="flex_buttons">
              <button type="button" className="button button-add" onClick={() => setShowModal(true)}>
                Add Item
              </button>
            </div>

            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>Part No</th>
                    <th>UOM</th>
                    <th>Unit Price</th>
                    <th>P.O Pending Qty</th>
                    <th>Recd. Qty</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedItems.length > 0 ? (
                    selectedItems.map((item, index) => {
                      const itemValue = item.OrderedQuantity * item.SupplierWIDetail_Price;
                      const discountValue = itemValue * (item.SupplierWIDetail_DiscountPercentage / 100);
                      const pfValue = itemValue * (item.SupplierWIDetail_PfPercentage / 100);
                      const taxValue = itemValue * (item.SupplierWIDetail_CSTtax / 100);
                      const totalValue = itemValue + taxValue + pfValue - discountValue;

                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.PurchaseOrderDetail_itemCode}</td>
                          <td>{item.itemMaster_name}</td>
                          <td>{item.itemMaster_drawingNumber}</td>
                          <td>{item.itemMaster_purchaseuom}</td>
                          <td>{item.PurchaseOrderDetail_price.toFixed(2)}</td>
                          <td>{item.PurchaseOrderDetail_orderedQuantity}</td>
                          <td>{item.PurchaseOrderDetail_receivedQuantity}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="10">No items added</td>
                    </tr>
                  )}
                </tbody>
              </table>

            </div>
            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Checkout
              </button>
            </div>
          </form>
        </div>
      </div>

      <GrnPOModal showModal={showModal} closeModal={() => setShowModal(false)} branch={branch} onSelectItem={handleSelectItem} />
    </div>
  );
};

export default AddGRN;
